export type PaginationResult<T> = {
  items: T[];
  page: number;
  page_size: number;
  page_count: number;
  total: number;
  start: number;
  end: number;
};

export function normalizeOpportunitySearchText(value: unknown): string {
  return String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
}

export function filterOpportunitiesBySearch<T>(items: T[], query: string, getSearchText: (item: T) => unknown = (item) => item): T[] {
  const normalizedQuery = normalizeOpportunitySearchText(query);
  if (!normalizedQuery) return items;
  return items.filter((item) => normalizeOpportunitySearchText(getSearchText(item)).includes(normalizedQuery));
}

export function paginateItems<T>(items: T[], page = 1, pageSize = 25): PaginationResult<T> {
  const safePageSize = [10, 25, 50, 100].includes(pageSize) ? pageSize : 25;
  const pageCount = Math.max(1, Math.ceil(items.length / safePageSize));
  const safePage = Math.min(Math.max(1, page), pageCount);
  const startIndex = (safePage - 1) * safePageSize;
  return { items: items.slice(startIndex, startIndex + safePageSize), page: safePage, page_size: safePageSize, page_count: pageCount, total: items.length, start: items.length ? startIndex + 1 : 0, end: Math.min(startIndex + safePageSize, items.length) };
}

export function getPaginationSummary(result: Pick<PaginationResult<unknown>, "start" | "end" | "total">): string {
  return result.total ? `Showing ${result.start}–${result.end} of ${result.total} opportunities` : "Showing 0 of 0 opportunities";
}
